import { createShowcaseBoxStyle } from "../../styles/showcase";
import { Link } from "wouter";

const ProgressBarComponents = () => {
	const boxStyle = createShowcaseBoxStyle(1);
	const textos = {
		titulo_texto: {
			uno: "Progress Bar One",
			dos: "Progress Bar Two",
			tres: "Progress Bar Three",
			cuatro: "Progress Bar Four",
			cinco: "Progress Bar Five",
			seis: "Progress Bar Six",
		},
	};

	return (
		<div className="flex flex-col gap-y-10">
			<div className={boxStyle.padre}>
				<h2 className={boxStyle.subtitulo}>Normal Progress Bars:</h2>
				{/* Progress Bar 1 */}
				<div className={boxStyle.hijo}>
					<h2 className={boxStyle.titulo}>{textos.titulo_texto.uno}</h2>
					<div className="mx-4 border rounded-xl p-4"/>
					<p className="text-xs text-center text-balance ">
						copy code{" "}
						<Link href="/PagesResources">
							<a className="underline underline-offset-2 text-sky-400 hover:text-sky-700">Just Here</a>
						</Link>
					</p>
				</div>
			</div>
			{/* ///////////////////////////////////// */}
		</div>
	);
};
export default ProgressBarComponents;


